/**
 * Konwertuje wartość w milimetrach na piksele (przy DPI 72)
 * 
 * @param {number} mm - wartość w milimetrach do konwersji
 * @returns {number} - odpowiadająca wartość w pikselach
 */
export const mmToPx = (mm) => {
  // Przy DPI 72, 1 mm = 72/25.4 px (25.4 mm = 1 cal)
  return mm * (72 / 25.4); // Około 2.835 px
};

/**
 * Konwertuje wartość w pikselach na milimetry (przy DPI 72)
 * 
 * @param {number} px - wartość w pikselach do konwersji
 * @returns {number} - odpowiadająca wartość w milimetrach
 */
export const pxToMm = (px) => {
  // Przy DPI 72, 1 px = 25.4/72 mm
  return px * (25.4 / 72); // Około 0.353 mm
};
